import { createFileRoute } from '@tanstack/react-router';
import { Icon } from '../components/Icon';

export const Route = createFileRoute('/outbound')({
  component: OutboundPage,
});

function OutboundPage() {
  return (
    <div>
      <h1 className="text-xl sm:text-2xl font-semibold mb-1">找客中心</h1>
      <p className="text-ink-3 text-xs sm:text-sm mb-5 sm:mb-6">
        W1 D6 实现：手动线索管理 + 行业目录 + Dork 串库
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-surface border border-line rounded p-5">
          <h3 className="text-sm font-semibold mb-2">🇯🇵 日本市场</h3>
          <ul className="text-xs text-ink-2 space-y-1">
            <li>· LinkedIn 主动（每天 1.5h）</li>
            <li>· jimoto ツクリ</li>
            <li>· バイヤー.com</li>
            <li>· 東京おもちゃショー（6 月）</li>
          </ul>
        </div>
        <div className="bg-surface border border-line rounded p-5">
          <h3 className="text-sm font-semibold mb-2">🇺🇸 美国市场</h3>
          <ul className="text-xs text-ink-2 space-y-1">
            <li>· LinkedIn 主动（每天 1.5h）</li>
            <li>· ThomasNet</li>
            <li>· Kompass</li>
            <li>· Toy Fair NY（2 月）</li>
          </ul>
        </div>
        <div className="bg-surface border border-line rounded p-5">
          <h3 className="text-sm font-semibold mb-2">🇨🇳 国内</h3>
          <ul className="text-xs text-ink-2 space-y-1">
            <li>· 1688 来电</li>
            <li>· 中国制造网 RFQ</li>
            <li>· 行业微信群</li>
            <li>· 广交会（4/10 月）</li>
          </ul>
        </div>
      </div>

      <div className="bg-surface border border-line rounded p-5">
        <h3 className="text-sm font-semibold mb-2 flex items-center gap-1.5">
          <Icon name="settings-2" size="sm" className="text-accent" />
          Dork 串库（30 条预制）
        </h3>
        <p className="text-xs text-ink-3">
          v1.5 实现一键复制 + 跳转 Google。复制以下到 Google 搜索试试：
        </p>
        <pre className="mt-3 bg-surface-2 p-3 rounded text-xs overflow-x-auto text-ink-2">
          {`"looking for" (manufacturer OR "OEM partner") toy 2025 OR 2026
"inurl:contact" (figurine OR "vinyl toy") (OEM OR "private label")
filetype:pdf "Toy Fair" 2025 OR 2026 exhibitor list
"we are looking for" "OEM manufacturer" (toy OR figurine OR collectible)`}
        </pre>
      </div>
    </div>
  );
}
